import { EditorState, ContentState } from 'draft-js';

export default (text, editorState) =>
    editorState
        ? EditorState.push(editorState, ContentState.createFromText(text || ''))
        : EditorState.createWithContent(ContentState.createFromText(text || ''));
